import React, { useState } from 'react';
import styles from './Picture.module.scss';
import { Icon } from 'components';
import { icons } from 'assets';
import { getImageOrientation, getImageInfo } from './utils';
import SettingIndicator from './SettingIndicator';
import { Props } from './types';

const Picture = (props: Props) => {
  const {
    src,
    alt = 'touche',
    className = '',
    size,
    saveOriginalDimensions,
    indications,
    removeCropping
  } = props;

  const [orientation, setOrientation] = useState('even');

  const handleImageInfo = () => {
    const img = getImageInfo(src);
    setOrientation(getImageOrientation(img));
    saveOriginalDimensions && saveOriginalDimensions(img.naturalWidth, img.naturalHeight);
  };

  return (
    <figure
      className={`${styles.figure} ${className}`}
      style={
        size
          ? { width: size, height: size }
          : {}
      }
    >
      {src
        ? <img
          src={src as string}
          alt={alt}
          className={styles[orientation]}
          onLoad={handleImageInfo}
        />
        : <Icon icon={icons.image} />
      }

      {indications &&
        <div className={styles.indicatorsContainer}>
          {indications.portraitCrop &&
            <SettingIndicator
              label='portrait'
              generalUse={indications.portraitForGeneralUse}
              removeCropping={removeCropping}
            />}
          {indications.squareCrop &&
            <SettingIndicator
              label='square'
              generalUse={indications.squareForGeneralUse}
              removeCropping={removeCropping}
            />}
        </div>}
    </figure>
  );
};

export default Picture;
